import Button from 'components/Button'
import {
  Card,
  CardContent,
  CardContentDescription,
  CardHeader,
  CardTitle,
} from 'components/Card'
import ProgressBar from 'components/ProgressBar'
import { observer } from 'mobx-react'
import React from 'react'
import JobViewModel from '../JobViewModel'
import EmptyTaskList from '../TasksCard/EmptyTaskList'
import VoiceCallCard from '../VoiceCallCard'

interface Props {
  vm: JobViewModel
}

export default observer(function ConsultationCallCard({ vm }: Props) {
  const completed = vm.job.completed

  if (vm.consultationIsPendingScheduling) {
    return <PendingSchedulingCard vm={vm} />
  }

  return (
    <VoiceCallCard
      completed={completed}
      completedState={
        <>
          <CardHeader>
            <CardTitle dataTest="current-task-title-new">
              Job Completed
            </CardTitle>
          </CardHeader>
          <CardContent>
            {completed && [
              <ProgressBar key={1} bars={[{ progress: 100 }]} />,
              <EmptyTaskList key={2} />,
            ]}
          </CardContent>
        </>
      }
      vm={vm}
      initialContent={{
        title: 'Prepare for the consultation',
        description:
          'Call scheduled with client. To start the consultation, prepare your audio settings.',
      }}
      completeOrPrepareContent={{
        title: 'Finalize the consultation',
        description:
          'Start another call with the client, or proceed to complete the job.',
      }}
      completeButton={
        <CardContent>
          <Button
            type="primary"
            size="wide-slim"
            dataTest="complete-job-new"
            onClick={vm.requestCloseAsCollaborator}
          >
            Complete Job
          </Button>
        </CardContent>
      }
    />
  )
})

export const PendingSchedulingContent = observer(
  function PendingSchedulingCard({ vm }: Props) {
    return (
      <>
        <CardHeader>
          <CardTitle dataTest="current-task-title">
            Prepare for the consultation
          </CardTitle>
        </CardHeader>
        <CardContent>
          <CardContentDescription>
            <p>{vm.consultationPendingSchedulingText}</p>
          </CardContentDescription>
        </CardContent>
      </>
    )
  }
)

const PendingSchedulingCard = observer(function PendingSchedulingCard({
  vm,
}: Props) {
  return (
    <Card>
      <PendingSchedulingContent vm={vm} />
    </Card>
  )
})
